import { defineStore } from 'pinia'

// Shared by concurrent callers (the like IDs and app.vue start it at the same time), so
// FingerprintJS is loaded and computed once
let initializing: Promise<void> | null = null

export const useFingerprintStore = defineStore('fingerprint', {
  state: () => ({
    visitorId: null as string | null,
    loaded: false
  }),
  actions: {
    initializeFingerprint() {
      if (this.loaded) return Promise.resolve()

      initializing ??= (async () => {
        try {
          const { getVisitorId } = useFingerprintJS()
          this.visitorId = await getVisitorId()
          this.loaded = true
        } catch (error) {
          console.error('Failed to initialize fingerprint:', error)
        } finally {
          initializing = null
        }
      })()

      return initializing
    }
  },
  getters: {
    getVisitorId: (state) => state.visitorId
  }
})
